<template>
  <div
    id="modalMarketplaceRedirect"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="modalMarketplaceRedirectLabel"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content border-0 shadow-lg overflow-hidden">
        <div class="modal-header border-0 pb-0 bg-light-primary">
          <div class="d-flex align-items-center gap-3 w-100">
            <div
              class="symbol symbol-50px symbol-circle bg-primary flex-shrink-0 d-flex align-items-center justify-content-center"
            >
              <i class="bi bi-shop text-white fs-2"></i>
            </div>
            <div>
              <h5 id="modalMarketplaceRedirectLabel" class="modal-title mb-0 text-gray-900">
                Você está no ambiente de gestão
              </h5>
              <p class="text-muted fs-7 mb-0">
                <span v-if="placeName">{{ placeName }} · </span>
                Perfil Marketplace
              </p>
            </div>
          </div>
          <button type="button" class="btn-close" aria-label="Fechar" @click="close"></button>
        </div>

        <div class="modal-body pt-6 pb-8 px-8">
          <div class="row g-6 align-items-stretch">
            <div class="col-md-6">
              <div class="card h-100 border border-primary bg-light-primary">
                <div class="card-body d-flex flex-column">
                  <span class="badge badge-light-primary align-self-start mb-3">Para este local</span>
                  <h4 class="text-gray-900 mb-2">
                    <i class="bi bi-bag-check text-primary me-2"></i>
                    Marketplace Ubbi
                  </h4>
                  <p class="text-gray-700 fs-6 mb-4 flex-grow-1">
                    Cadastre serviços, preços e disponibilidade para vender consultas, exames e outros
                    atendimentos no marketplace de venda da Ubbimed.
                  </p>
                  <a
                    :href="marketplaceUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="btn btn-primary w-100"
                  >
                    Acessar marketplace.ubbimed.com.br
                    <i class="bi bi-box-arrow-up-right ms-2"></i>
                  </a>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card h-100 border border-gray-300">
                <div class="card-body d-flex flex-column">
                  <span class="badge badge-light-primary align-self-start mb-3">Gestão completa</span>
                  <h4 class="text-gray-900 mb-2">
                    <i class="bi bi-hospital text-primary me-2"></i>
                    Sistema de gestão
                  </h4>
                  <p class="text-gray-700 fs-6 mb-4 flex-grow-1">
                    Agenda, prontuário, financeiro, convênios, TISS e demais módulos para administrar
                    a operação da clínica — no mesmo cadastro, ativando o plano neste local.
                  </p>
                  <router-link
                    :to="{ path: '/subscription/ativar-gestao', query: { id_place: placeId } }"
                    class="btn btn-light-primary w-100"
                    @click="close"
                  >
                    Escolher plano de gestão
                    <i class="bi bi-arrow-right ms-2"></i>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div class="notice d-flex bg-light rounded border border-dashed border-gray-300 p-4 mt-6">
            <i class="bi bi-info-circle text-primary fs-3 me-3 flex-shrink-0"></i>
            <span class="text-gray-700 fs-7">
              Este local está configurado como marketplace. Para vender serviços, use o portal
              acima. Para usar o sistema de gestão, escolha um plano — sua conta permanece a mesma.
            </span>
          </div>
        </div>

        <div class="modal-footer border-0 pt-0 px-8 pb-8">
          <button type="button" class="btn btn-light" @click="close">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '../config';

export default {
  name: 'ModalMarketplaceRedirect',
  props: {
    placeName: {
      type: String,
      default: '',
    },
    placeId: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ['closed'],
  data() {
    return {
      marketplaceUrl: Config.marketplace_url,
      modalInstance: null,
    };
  },
  mounted() {
    const el = document.getElementById('modalMarketplaceRedirect');
    this.modalInstance = bootstrap.Modal.getOrCreateInstance(el, {
      backdrop: 'static',
      keyboard: false,
    });
  },
  beforeUnmount() {
    this.modalInstance?.hide();
  },
  methods: {
    open() {
      this.modalInstance?.show();
    },
    close() {
      this.modalInstance?.hide();
      this.$emit('closed');
    },
  },
};
</script>
